// extracted by mini-css-extract-plugin
module.exports = {"pause-button-wrapper":"PauseButton_pause-button-wrapper___5jC4","visually-hidden":"PauseButton_visually-hidden__ZVLDw","tooltip":"PauseButton_tooltip__k1Xuo"};